import types from '../types';
import { combineReducers } from 'redux';
import { chatroomsReducer } from './reducer.chatrooms';
import { chatroomsListsReducer } from './reducer.chatrooms-lists';
import { messageDraftReducer } from './reducer.message-draft';
import { messagesReducer } from './reducer.messages';
import { participantsReducer } from './reducer.participants';
import { messagesIndicationsReducer } from './reducer.messages-indications';
import { unseenChatroomCountReducer } from '../../modules/unseen-chatroom-count/reducer.unseen-chatroom-count';
import { unreadChatroomCountReducer } from '../../modules/unread-chatroom-count/reducer.unread-chatroom-count';
import { unreadChatroomCountReducer as unreadChatroomCountReducerV2 } from '../../modules/unread-chatroom-count-v2/reducer.unread-chatroom-count';
import { presenceReducer } from '../../presence/reducer.presence';
var appReducer = combineReducers({
    chatrooms: chatroomsReducer,
    chatroomsLists: chatroomsListsReducer,
    messages: messagesReducer,
    messageDraft: messageDraftReducer,
    participants: participantsReducer,
    messagesIndications: messagesIndicationsReducer,
    unseenChatroomCount: unseenChatroomCountReducer,
    unreadChatroomCount: unreadChatroomCountReducer,
    unreadChatroomCountV2: unreadChatroomCountReducerV2,
    presence: presenceReducer,
});
var rootReducer = function (state, action) {
    if (action.type === types.RESET_STORE) {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};
export { rootReducer, chatroomsReducer, messagesReducer };
